(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var Q = __webpack_require__(2);

	var OpenrestClient = __webpack_require__(3).OpenrestClient;

	var apiUrl = null;

	var _requests = {};
	var _monitor = 0;
	var _batch = null;

	module.exports = {
	    request: function request(params) {
	        var _client = new OpenrestClient({ XMLHttpRequest: XMLHttpRequest, apiUrl: apiUrl || "https://api.wixrestaurants.com/v1.1", timeout: params.timeout });

	        var request = params.request;
	        var _callback = params.callback;
	        var client = params.client || _client;

	        var defer = Q.defer();
	        var startTime = new Date().getTime();
	        _requests[request.type] = _requests[request.type] || [];

	        if (_batch) {
	            _batch.push({ params: params, defer: defer });
	            return defer.promise;
	        }

	        client.request({
	            request: request,
	            callback: function callback(e) {
	                var t = new Date().getTime() - startTime;
	                _monitor++; // Monitor only first 100 transactions
	                if (e.error) {
	                    if (_monitor < 100) _requests[request.type].push({ 's': false, 't': t });
	                    defer.reject(e);
	                } else {
	                    if (_monitor < 100) _requests[request.type].push({ 's': true, 't': t });
	                    defer.resolve(e);
	                }

	                if (_callback) {
	                    _callback(e);
	                }
	            }
	        });

	        return defer.promise;
	    },
	    setApiUrl: function setApiUrl(val) {
	        apiUrl = val;
	    },
	    getPerformance: function getPerformance() {
	        return _requests;
	    },
	    setBatch: function setBatch() {
	        _batch = _batch || [];
	    },
	    releaseBatch: function releaseBatch() {
	        var batch = _batch;
	        _batch = null;

	        var requests = batch.map(function (b) {
	            return b.params.request;
	        });

	        this.request({ request: { type: 'batch', requests: requests } }).then(function (result) {
	            var responses = result.value.responses;
	            responses.forEach(function (response, index) {
	                if (response.error) {
	                    batch[index].defer.reject(response);
	                } else {
	                    batch[index].defer.resolve(response);
	                }
	                if (batch[index].params.callback) {
	                    batch[index].params.callback(response);
	                }
	            });
	        }).catch(function (error) {
	            batch.forEach(function (b) {
	                b.reject(error);
	                if (b.params.callback) {
	                    bparams.callback(error);
	                }
	            });
	        });
	    }
	};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("q");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = require("openrest4js");

/***/ })
/******/ ])));


//////////////////
// WEBPACK FOOTER
// ../node_modules/openrest/dist/index.js
// module id = 383
// module chunks = 0